import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  constructor(
    private readonly http: HttpClient,
    private readonly authenticationService: AuthenticationService
  ) { }

  public async changeUserPassword({ oldPassword, newPassword }): Promise<void> {
    const url = `${environment.MORANNON_URL}/auth/change-password`;
    await this.http.post(url, {
      accessToken: this.authenticationService.accessToken,
      oldPassword,
      newPassword
    })
      .toPromise();
  }

  public generatePassword(): string {
    let password = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$';

    for (let i = 0; i < 8; i++) {
      password += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    if (this.isValidPassword(password)) {
      return password;
    } else {
      return this.generatePassword();
    }
  }

  private isValidPassword(password: string): boolean {
    const checks = [
      /[A-Z]/.test(password),
      /[a-z]/.test(password),
      /\d/.test(password),
      /[@#$]/.test(password),
    ];

    return checks.reduce((sum, current) => sum + Number(current), 0) === 4;
  }
}
